import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Users, Coins, Menu, Store } from 'lucide-react';
import { useAppState } from '../../context/AppStateContext';
import { useAuth } from '../../context/AuthContext';

const navItems = [
  { id: 'home', path: '/home', icon: Home, label: 'Home' },
  { id: 'marketplace', path: '/marketplace', icon: Store, label: 'Shop' },
  { id: 'groups', path: '/groups', icon: Users, label: 'Groups' },
  { id: 'dashboard', path: '/dashboard', icon: Coins, label: 'Rewards' },
  { id: 'menu', path: '/menu', icon: Menu, label: 'Menu' },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setSelectedGroup, setMenuScreen } = useAppState();
  const { isGuestMode, setShowGuestPrompt } = useAuth();

  const handleTabChange = (item) => {
    // Guest users clicking Groups, Rewards, or Menu should see the sign up drawer
    if (['groups', 'dashboard', 'menu'].includes(item.id) && isGuestMode) {
      setShowGuestPrompt(true);
      return;
    }

    // Reset sub-screens when changing tabs
    if (item.id !== 'groups') {
      setSelectedGroup(null);
    }
    if (item.id !== 'menu') {
      setMenuScreen(null);
    }
    navigate(item.path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 z-50 pb-safe">
      <div className="flex items-center justify-around h-20 max-w-lg mx-auto">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;

          return (
            <button
              key={item.id}
              onClick={() => handleTabChange(item)}
              className={`flex flex-col items-center justify-center w-14 h-16 rounded-2xl transition-all duration-200 touch-manipulation ${
                isActive
                  ? 'text-indigo-600'
                  : 'text-gray-400 hover:text-gray-600'
              }`}
            >
              <Icon
                size={24}
                strokeWidth={isActive ? 2.5 : 2}
                className="mb-1"
              />
              <span className={`text-xs ${isActive ? 'font-bold' : 'font-medium'}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
